import instagramApi from '../../../../common/apis/instagramApi';
import type { Clip } from '../../clipQueueSlice';
import type { ClipProvider } from '../providers';
import { createLogger } from '../../../../common/logging';

const logger = createLogger('InstagramProvider');

class InstagramProvider implements ClipProvider {
  name = 'instagram';

  getIdFromUrl(url: string): string | undefined {
    try {
      console.log('[InstagramProvider] getIdFromUrl called with:', url);
      const uri = new URL(url);
      console.log('[InstagramProvider] Hostname:', uri.hostname, 'Pathname:', uri.pathname);

      if (uri.hostname.endsWith('instagram.com')) {
        console.log('[InstagramProvider] Hostname matches Instagram pattern');
        // Match both /reel/ID, /reels/ID and /p/ID patterns
        const match = uri.pathname.match(/\/(reels?|p)\/([A-Za-z0-9_-]+)/);

        if (match) {
          console.log('[InstagramProvider] Extracted ID:', match[2]);
          return match[2];
        } else {
          console.log('[InstagramProvider] Path did not match reel/post pattern');
        }
      } else {
        console.log('[InstagramProvider] Hostname did not match Instagram pattern');
      }
      return undefined;
    } catch (error) {
      console.error('[InstagramProvider] Error parsing URL:', error);
      return undefined;
    }
  }

  async getClipById(id: string): Promise<Clip | undefined> {
    if (!id) return undefined;

    logger.info('Creating Instagram clip for ID:', id);

    // Instagram's oEmbed API is restricted, so we'll create a clip without fetching metadata
    // The embed will still work via iframe
    const clip = {
      id,
      title: 'Instagram Video',
      author: 'Instagram User',
      url: this.getUrl(id),
      thumbnailUrl: undefined,
      submitters: [],
      Platform: 'Instagram' as const,
    };

    logger.info('Returning Instagram clip:', clip);
    return clip;
  }

  getUrl(id: string): string | undefined {
    return `https://www.instagram.com/reel/${id}`;
  }

  getEmbedUrl(id: string): string | undefined {
    return `https://www.instagram.com/reel/${id}/embed`;
  }

  async getAutoplayUrl(id: string): Promise<string | undefined> {
    return undefined; // Instagram embeds don't reliably support autoplay
  }
}

const instagramProvider = new InstagramProvider();
export default instagramProvider;
